import React, { Component } from 'react';

import { Form, Label, Input, Button, Dropdown } from '../../Form';

class Practice extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: false
    };
  }

  render() {
    const { isValid } = this.state;
    const { previous, data, translate } = this.props;
    
    return (
      <Form
        ref={form => (this.form = form)}
        onValidationChange={valid => this.setState({ isValid: valid })}
        onSubmit={({ body }) => this.props.store(body)}
      >
        <Label text={translate('register.practice.country')} />
        <Dropdown
          name="country"
          data={translate('register.practice.countries')}
          rules={['required']}
          defaultValue={data.country}
        />

        <div className="Form__Horizontal">
          <div className="Form__Horizontal__Item">
            <Label text={translate('register.practice.street')} />
            <Input name="street" rules={['required']} defaultValue={data.street} />
          </div>
          <div className="Form__Horizontal__Item Form__Horizontal__Item--30">
            <Label text={translate('register.practice.house_number')} />
            <Input name="house_number" rules={['required']} defaultValue={data.house_number} />
          </div>
        </div>

        <div className="Form__Horizontal">
          <div className="Form__Horizontal__Item">
            <Label text={translate('register.practice.postal_code')} />
            <Input name="postal_code" rules={['required']} defaultValue={data.postal_code} />
          </div>
          <div className="Form__Horizontal__Item">
            <Label text={translate('register.practice.city')} />
            <Input name="city" rules={['required']} defaultValue={data.city} />
          </div>
        </div>

        <Button solid className="Form__Button" disabled={!isValid}>
          {translate('register.next')}
        </Button>
        <Button transparant className="Form__Button" onClick={() => previous()}>
          {translate('register.previous')}
        </Button>
      </Form>
    );
  }
}

export default Practice;
